/* global display */
import commonutils from '../utils/common';
export default class Wrapper {
  constructor(el, id) {
    this.el = el;
    this.id = id;
    this.haswrapperheading = this.el.querySelector('.wrapper_heading')
      ? true
      : false;
    this.hasfloatingnav = this.el.querySelector('.links') ? true : false;
    this.tileheadings = [...this.el.querySelectorAll('.tile h2')];
    this.haswrapperheading ? this.replaceheadings(this.tileheadings) : null;
    !this.haswrapperheading ? this.el.classList.add('has-no-heading') : null;
    this.accordionheadings = [...this.el.querySelectorAll('.heading_title h2')];
    try {
      this.replaceheadings(this.accordionheadings);
    } catch (e) {
      console.warn('No headings found to replace in wrapper', e);
    }
    //this.haswrapperheading ? this.replaceheadings() : null;
    this.hasfloatingnav ? this.addoverflowfix() : null;
    this.el.dataset.collapsible ? this.makecollapsible() : false;
    el.dataset.tilesInheritBackgroundColour
      ? this.tilesinheritbackgroundcolour(
          el.dataset.tilesInheritBackgroundColour
        )
      : false;
    //this.maketile();
  }

  replaceheadings(headings) {
    //give element a class of 'has-no-heading' if it has no headings
    // this.el.classList.add('has-no-heading');
    //check headings before replacing
    if (headings && headings.length !== 0) {
      headings.forEach((el) => {
        let newheading = document.createElement('h3');
        newheading.innerHTML = el.innerHTML;
        el.parentNode.replaceChild(newheading, el);
      });
    }
  }

  tilesinheritbackgroundcolour(backgroundcolour) {
    [...this.el.querySelectorAll('.tile')].forEach((tile) => {
      tile.className = '';
      tile.classList.add(
        backgroundcolour.trim(),
        'tile',
        'no-shadow',
        'no-padding',
        'panel' //contentPanel jumpLink alt solid block singleContentElement TileBackgroundDefault cobalt
      );
    });
  }

  makecollapsible() {
    const collapsiblewrapper = document.createElement('div');
    const classList = ['row', 'standardContent', 'racc_parent', 'wrapper-racc'];
    // Only add background class if it exists
    if (this.el.dataset.backgroundclass) {
      classList.push(this.el.dataset.backgroundclass.replace(/\s+/g, '-'));
    }
    collapsiblewrapper.classList.add(...classList);
    const collapsibleinner = document.createElement('div');
    collapsibleinner.classList.add(
      'racc',
      'columns',
      'content',
      'twelve',
      'large-12',
      'medium-12'
    );
    const collapsiblecontent = document.createElement('div');
    collapsiblecontent.classList.add('content_opener', 'contains-wrapper');

    commonutils.wrap(this.el, collapsiblewrapper);
    commonutils.wrap(this.el, collapsibleinner);

    this.el.insertAdjacentHTML(
      'beforebegin',
      `<div class="heading_opener heading_title"><h2>${this.el.dataset.collapsible.replace(/\\'/g, "'")}</h2></div>`
    );

    commonutils.wrap(this.el, collapsiblecontent);

    this.el.classList.add('in-accordion');
    this.el.classList.remove('wrapper');

    /**accordions */
    function getAccordion() {
      return import(
        /* webpackChunkName: "gu-accordion" */ '../content/accordion'
      )
        .then(({ default: Accordion }) => {
          return Accordion;
        })
        .catch(() => 'An error occurred while loading the component');
    }

    getAccordion().then((Accordion) => {
      new Accordion('racc');
    });
  }

  maketile() {
    this.el.classList.add('istile');
    this.el.insertAdjacentHTML(
      'afterend',
      `
        <div class="large-6 medium-6 columns end tileContainer wrapper-tileContainer" data-colspan="6">
            <div id="tile-wrapper-${this.id}" class="tile panel TileBackground-was-wrapper">
            </div>
        </div>
    `
    );
    document
      .getElementById(`tile-wrapper-${this.id}`)
      .insertAdjacentElement('beforeend', this.el);
    /**tiles */
    function getTiles() {
      return import(/* webpackChunkName: "gu-tiles" */ '../content/tiles')
        .then(({ default: Tiles }) => {
          return Tiles;
        })
        .catch(() => 'An error occurred while loading the component');
    }
    getTiles().then((Tiles) => {
      new Tiles('.tileContainer');
      //images
      let ticking = false;
      display.lazyloadimages();
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            display.lazyloadimages();
            ticking = false;
          });
          ticking = true;
        }
      });
    });
  }

  addoverflowfix() {
    this.el.classList.add('floating-nav-overflow-fix');
  }
}
